import Firebase from 'firebase'

let config = {
  apiKey: process.env.VUE_APP_FIREBASE_API_KEY,
  authDomain: process.env.VUE_APP_FIREBASE_PROJECT_ID + '.firebaseapp.com',
  databaseURL: 'https://' + process.env.VUE_APP_FIREBASE_PROJECT_ID + '.firebaseio.com',
  projectId: process.env.VUE_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.VUE_APP_FIREBASE_PROJECT_ID + '.appspot.com'
  // messagingSenderId: '446085254058'
}

const fb = Firebase.initializeApp(config)
console.log('You are using Project ID: ', process.env.VUE_APP_FIREBASE_PROJECT_ID)
console.log('You are using mode: ', process.env.NODE_ENV)

// firebase
const db = fb.database()
const storiesRef = db.ref('stories')
const usersRef = db.ref('users')
const assetsRef = db.ref('assets')
const testRef = db.ref('tests')
const timelinesRef = db.ref('timelines')
const assetMediaStorageRef = Firebase.storage().ref().child('assetMedia/images/')
const assetAudioStorageRef = Firebase.storage().ref().child('assetMedia/audio/')
const assetModelStorageRef = Firebase.storage().ref().child('assetMedia/models/')
const assetPropStorageRef = Firebase.storage().ref().child('assetMedia/props/')
const jsonFileStorageRef = Firebase.storage().ref('storyExport/')
export {
  Firebase,
  db,
  timelinesRef,
  assetMediaStorageRef,
  storiesRef,
  usersRef,
  assetsRef,
  testRef,
  assetAudioStorageRef,
  jsonFileStorageRef,
  assetModelStorageRef,
  assetPropStorageRef
}



// WEBPACK FOOTER //
// ./src/firebaseDB.js